import { useEffect, useState } from 'react';
import api from '../services/api';
import Avatar from '../components/Avatar';

const fmtDate = (d) => d ? new Date(d).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
const fmt = (n) => Number(n || 0).toLocaleString('fr-FR');

const STATUS_BADGE = {
  pending:   ['#fef9c3', '#854d0e', '⏳ En attente'],
  converted: ['#dcfce7', '#166534', '✓ Converti'],
  expired:   ['#f1f5f9', '#64748b', '✕ Expiré'],
};

export default function Referrals() {
  const [data, setData] = useState({ referrals: [], top_referrers: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/referrals')
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 280 }}><div className="spinner" /></div>;

  return (
    <div className="animate-fade">
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>Parrainages</h2>
        <p style={{ fontSize: 13, color: 'var(--text-muted)' }}>Suivi des invitations et conversions</p>
      </div>

      {/* Top parrains */}
      <h3 style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10 }}>Top 10 parrains</h3>
      <div className="card" style={{ marginBottom: 28 }}>
        <div className="card-body">
          {data.top_referrers.length === 0 ? (
            <div style={{ padding: 24, textAlign: 'center', color: 'var(--text-muted)' }}>Aucun parrain encore</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid var(--border)', textAlign: 'left' }}>
                  <th style={th}>#</th>
                  <th style={th}>Parrain</th>
                  <th style={th}>Code</th>
                  <th style={{ ...th, textAlign: 'right' }}>Invités</th>
                  <th style={{ ...th, textAlign: 'right' }}>Convertis</th>
                  <th style={{ ...th, textAlign: 'right' }}>Bonus gagnés</th>
                </tr>
              </thead>
              <tbody>
                {data.top_referrers.map((u, i) => (
                  <tr key={u.id} style={{ borderBottom: '1px solid var(--border)' }}>
                    <td style={{ ...td, fontWeight: 800, fontSize: 16 }}>#{i + 1}</td>
                    <td style={td}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <Avatar name={u.name} size="sm" />
                        <div>
                          <div style={{ fontWeight: 600 }}>{u.name}</div>
                          <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{u.phone}</div>
                        </div>
                      </div>
                    </td>
                    <td style={{ ...td, fontFamily: 'monospace', fontWeight: 700 }}>{u.referral_code}</td>
                    <td style={{ ...td, textAlign: 'right', fontWeight: 700 }}>{u.total}</td>
                    <td style={{ ...td, textAlign: 'right', fontWeight: 700, color: 'var(--success)' }}>{u.converted}</td>
                    <td style={{ ...td, textAlign: 'right', fontWeight: 800 }}>{fmt(u.earned)} F</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Détail */}
      <h3 style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10 }}>Détail ({data.referrals.length})</h3>
      <div className="card">
        <div className="card-body">
          {data.referrals.length === 0 ? (
            <div style={{ padding: 24, textAlign: 'center', color: 'var(--text-muted)' }}>Aucun parrainage</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ borderBottom: '1px solid var(--border)', textAlign: 'left' }}>
                  <th style={th}>Date</th>
                  <th style={th}>Parrain</th>
                  <th style={th}>Filleul</th>
                  <th style={th}>Statut</th>
                  <th style={th}>Converti le</th>
                  <th style={{ ...th, textAlign: 'right' }}>Bonus</th>
                </tr>
              </thead>
              <tbody>
                {data.referrals.map(r => {
                  const [bg, color, label] = STATUS_BADGE[r.status] || ['#f1f5f9', '#64748b', r.status];
                  return (
                    <tr key={r.id} style={{ borderBottom: '1px solid var(--border)' }}>
                      <td style={td}>{fmtDate(r.created_at)}</td>
                      <td style={td}>
                        <div style={{ fontWeight: 600 }}>{r.referrer_name}</div>
                        <div style={{ fontSize: 11, color: 'var(--text-muted)', fontFamily: 'monospace' }}>{r.referral_code}</div>
                      </td>
                      <td style={td}>
                        <div>{r.referred_name}</div>
                        <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{r.referred_phone}</div>
                      </td>
                      <td style={td}><span style={{ background: bg, color, padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700 }}>{label}</span></td>
                      <td style={td}>{r.converted_at ? fmtDate(r.converted_at) : '—'}</td>
                      <td style={{ ...td, textAlign: 'right', fontWeight: 700, color: r.status === 'converted' ? 'var(--success)' : 'var(--text-muted)' }}>{fmt(r.bonus_amount)} F</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

const th = { padding: '10px 8px', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, color: 'var(--text-muted)' };
const td = { padding: '12px 8px', color: 'var(--text-primary)', verticalAlign: 'top' };
